import { useEffect, useState } from "react";
import { siteMeta } from "@/mocks/gossipData";

const navLinks = [
  { href: "#focus", label: "本周焦点" },
  { href: "#feed", label: "瓜料速览" },
  { href: "#timeline", label: "近期动态" },
  { href: "#special", label: "深度盘点" },
  { href: "#about", label: "关于口碑" },
  { href: "#faq", label: "常见问题" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "fixed top-0 left-0 right-0 z-50 transition-colors duration-300 " +
        (scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent")
      }
    >
      <nav className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 items-center justify-between">
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-play text-xl text-primary-600">{siteMeta.brand}</span>
              <span className="mt-0.5 text-[10px] tracking-widest text-foreground-500">
                {siteMeta.slogan.split(" · ")[0]}
              </span>
            </span>
          </a>

          <div className="hidden items-center gap-7 lg:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              订阅瓜报
            </a>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 lg:hidden"
            aria-label="打开菜单"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>

        {open && (
          <div className="flex flex-col gap-1 border-t border-background-200 py-4 lg:hidden">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50 hover:bg-primary-600"
            >
              订阅瓜报
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}